// src/utils/tracking.js

const COOKIE_REFERRAL = 'ref_code';
const COOKIE_UTM = 'utm_tag';
const COOKIE_LOCALE = 'user_locale';

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

function setCookie(name, value, days = 30) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=/`;
}

// Сохранить ref, utm и locale из URL в куки
export function captureTrackingParams(locale) {
  const urlParams = new URLSearchParams(window.location.search);
  
  const ref = urlParams.get('r');
  const utm = urlParams.get('utm');
  
  if (ref) {
    setCookie(COOKIE_REFERRAL, ref);
  }
  
  if (utm) {
    setCookie(COOKIE_UTM, utm);
  }

  // Сохраняем локаль, если передана
  if (locale) {
    setCookie(COOKIE_LOCALE, locale);
  }
}

// Получить сохранённые параметры
export function getTrackingParams() {
  const urlParams = new URLSearchParams(window.location.search);
  
  const ref = urlParams.get('r') || getCookie(COOKIE_REFERRAL);
  const utm = urlParams.get('utm') || getCookie(COOKIE_UTM);
  const locale = getCookie(COOKIE_LOCALE);
  
  return {
    referral_code: ref || null,
    utm: utm || null,
    locale: locale || null,
  };
}